import * as React from 'react';

interface SuccessToastProps {
    message: string;
    show: boolean;
}

export const SuccessToast: React.FC<SuccessToastProps> = ({ message, show }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="alert alert-success" style={{ position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)', zIndex: 1050, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
            {message}
        </div>
    );
};
